// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivateFooter_container__Bd7bC"};